(function () {
  'use strict';

  function getContext() {
    var container = document.querySelector('.t4s-main-collection-page[data-ntajax-container][data-ntajax-options]');
    if (!container) return null;
    try {
      var options = JSON.parse(container.getAttribute('data-ntajax-options'));
      return {
        container: container,
        facets: document.getElementById('shopify-section-' + options.typeFilters)
      };
    } catch (error) {
      return null;
    }
  }

  function runNativeFilter(url) {
    var context = getContext();
    var links = context && context.facets && context.facets.querySelector('[data-filter-links]');
    if (!links) {
      window.location.href = url;
      return;
    }
    var link = document.createElement('a');
    link.href = url;
    link.hidden = true;
    links.appendChild(link);
    link.click();
    link.remove();
  }

  function formUrl(form) {
    var url = new URL(form.action, window.location.origin);
    url.search = new URLSearchParams(new FormData(form)).toString();
    return url.toString();
  }

  function refresh(root) {
    if (root.dataset.refreshing) return;
    root.dataset.refreshing = 'true';
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', root.dataset.sectionId);
    fetch(url.toString(), { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-livish-desktop-filters]');
        if (next && root.isConnected) root.innerHTML = next.innerHTML;
      })
      .finally(function () { delete root.dataset.refreshing; });
  }

  function formatMoney(value) {
    if (window.T4SThemeSP && T4SThemeSP.Currency && T4SThemeSP.Currency.formatMoney) return T4SThemeSP.Currency.formatMoney(value);
    return (value / 100).toFixed(2);
  }

  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    root.addEventListener('change', function (event) {
      var checkbox = event.target.closest('[data-livish-desktop-filter-input]');
      var price = event.target.closest('[data-livish-desktop-price-min], [data-livish-desktop-price-max]');
      if (checkbox) runNativeFilter(formUrl(checkbox.closest('form')));
      else if (price) runNativeFilter(formUrl(price.closest('form')));
    });

    root.addEventListener('input', function (event) {
      var range = event.target.closest('[data-livish-desktop-price-min], [data-livish-desktop-price-max]');
      if (!range) return;
      var form = range.closest('form');
      var minRange = form.querySelector('[data-livish-desktop-price-min]');
      var maxRange = form.querySelector('[data-livish-desktop-price-max]');
      var min = Number(minRange.value);
      var max = Number(maxRange.value);
      if (min > max) {
        if (range === minRange) min = max;
        else max = min;
      }
      minRange.value = min;
      maxRange.value = max;
      var ranges = minRange.closest('.t4s-livish-desktop-filters__ranges');
      var rangeMax = Number(maxRange.max) || 1;
      ranges.style.setProperty('--ldf-price-min', min / rangeMax * 100 + '%');
      ranges.style.setProperty('--ldf-price-max', max / rangeMax * 100 + '%');
      form.querySelector('[data-livish-desktop-price-min-field]').value = (min / 100).toFixed(2);
      form.querySelector('[data-livish-desktop-price-max-field]').value = (max / 100).toFixed(2);
      form.querySelector('[data-livish-desktop-price-min-label]').textContent = formatMoney(min);
      form.querySelector('[data-livish-desktop-price-max-label]').textContent = formatMoney(max);
    });

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-livish-desktop-filter-form]');
      if (!form) return;
      event.preventDefault();
      runNativeFilter(formUrl(form));
    });

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-livish-filter-link]');
      if (!link) return;
      event.preventDefault();
      runNativeFilter(link.href);
    });

    var context = getContext();
    if (context && window.MutationObserver) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { refresh(root); }, 50);
      }).observe(context.container, { childList: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-livish-desktop-filters]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
